import { CompanyContactPersonModel, MerchantModel } from '@/shared/models/merchant.model';
import { CompanyContactPersonUIModel } from '@/shared/ui-models/merchants.ui-model';

function mapToModel(
  merchantId: string,
  contactPerson: CompanyContactPersonUIModel,
  initialValues?: CompanyContactPersonUIModel
): CompanyContactPersonModel {
  return {
    ...(merchantId && { id: merchantId }),
    ...(contactPerson.jobTitleEn && {
      contactPersonJobTitle: {
        en: contactPerson.jobTitleEn,
        ar: (initialValues ? initialValues.jobTitleAr : contactPerson.jobTitleAr) ?? ''
      }
    }),
    ...(contactPerson.jobTitleAr && {
      contactPersonJobTitle: {
        en: (initialValues ? initialValues.jobTitleEn : contactPerson.jobTitleEn) ?? '',
        ar: contactPerson.jobTitleAr
      }
    }),
    ...(contactPerson.nameEn && {
      contactPersonName: {
        en: contactPerson.nameEn,
        ar: (initialValues ? initialValues.nameAr : contactPerson.nameAr) ?? ''
      }
    }),
    ...(contactPerson.nameAr && {
      contactPersonName: {
        en: (initialValues ? initialValues.nameEn : contactPerson.nameEn) ?? '',
        ar: contactPerson.nameAr
      }
    }),
    ...(contactPerson.email && { contactPersonEmail: contactPerson.email }),
    ...(contactPerson.phoneNumber && {
      contactPersonPhoneNumber: contactPerson.phoneNumber
    })
  };
}

function mapToUI(merchant: MerchantModel): CompanyContactPersonUIModel {
  return {
    id: merchant.id,
    jobTitleEn: merchant.contactPersonJobTitle?.en ?? '',
    jobTitleAr: merchant.contactPersonJobTitle?.ar ?? '',
    nameEn: merchant.contactPersonName?.en ?? '',
    nameAr: merchant.contactPersonName?.ar ?? '',
    email: merchant.contactPersonEmail ?? '',
    phoneNumber: merchant.contactPersonPhoneNumber ?? ''
  };
}

const contactPersonMapper = { mapToModel, mapToUI };

export default contactPersonMapper;
